import delibranLogo from "../../assets/logo/logo-delibran.svg";
import { useLogout } from "../../hooks/useLogout";
import React, { useRef, useState, useEffect } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, setAlert, updateRequestIsOrder, setUserLogOut } from "../../reducers/userConfigSlice";

import { LuWallet } from "react-icons/lu";
import { HiLogout } from "react-icons/hi";
import { VscHistory } from "react-icons/vsc";
import { FiShoppingCart, FiChevronDown, FiClock } from "react-icons/fi";

import "./style.css";
import { LiaExchangeAltSolid } from "react-icons/lia";
import { flushAllProductChanges } from "../../services/productSyncQueue";
import { lockOperator } from "../../api/login";
import { readLoginLS, saveLoginLS } from "@delibrandev/utils";
import { apiRest } from "../../api/constants";

const ClockStatus=()=>{const [clock,setClock]=useState(new Date()),[online,setOnline]=useState(navigator.onLine);useEffect(()=>{const timer=setInterval(()=>setClock(new Date()),30000);const update=()=>setOnline(navigator.onLine);window.addEventListener('online',update);window.addEventListener('offline',update);return()=>{clearInterval(timer);window.removeEventListener('online',update);window.removeEventListener('offline',update);};},[]);return <div className="tpvClockStatus"><FiClock aria-hidden="true"/><time>{clock.toLocaleTimeString('es-ES',{hour:'2-digit',minute:'2-digit'})}</time><small className={online?'':'is-offline'} title="Estado de conexión del dispositivo">● {online?'Online':'Sin conexión'}</small></div>;};
export const Header = () => {
  const dispatch = useDispatch();
  const inFlight = useRef(false);
  const [pending, setPending] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);
  const { logout, busy: loggingOut } = useLogout();
  const user = useSelector((state) => state.aplicationConfig.userConfig.data);
  const pointName = useSelector((state) => state.aplicationConfig.corporationData?.pointConfig?.name);
  const componentActive = useSelector((state) => state.aplicationConfig.userConfig.componentActive);
  const shoppingCartId = useSelector((state) => state.aplicationConfig.userConfig.cart?.shoppingCartId);

  const ensureProductChangesSaved = async () => {
    const synchronized = await flushAllProductChanges();
    if (!synchronized) {
      dispatch(
        setAlert({
          called: true,
          title: "Sincronización",
          message: "Hay cambios sin guardar. La operación se ha cancelado.",
        }),
      );
    }
    return synchronized;
  };

  const runAction = async (action) => {
    if (inFlight.current || loggingOut) return;
    inFlight.current = true;
    setPending(true);
    try {
      await action();
    } catch {
      dispatch(
        setAlert({
          called: true,
          title: "Operación no completada",
          message: "No se pudo completar la operación. Vuelve a intentarlo.",
        }),
      );
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  const logOff = () =>
    runAction(async () => {
      if (await ensureProductChangesSaved()) await logout();
    });

  const handleMenu = (component) =>
    runAction(async () => {
      if (component !== componentActive && !(await ensureProductChangesSaved())) return;
      if (component === "switchAccount") {
        const response = await lockOperator({ shoppingCartId });
        if (response?.error !== false) throw new Error("Operator lock not confirmed");
        const point = readLoginLS(apiRest)?.point;
        saveLoginLS(point ? { point } : {}, apiRest);
        dispatch(setUserLogOut());
      }
      if (component === "commander" && componentActive !== "commander") {
        dispatch(updateRequestIsOrder(false));
      }
      dispatch(setComponentActive(component));
    });
  const busy = pending || loggingOut;
  const keyboardAction = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  return (
    <>
      <header className="commander-header">
        <div className="tpvBrand">
          <img src={delibranLogo} alt="Delibrán" />
          <span>
            TPV <span className="tpvStation">· {pointName || "Punto de venta"}</span>
          </span>
        </div>
        <ClockStatus/>
        <details
          className="tpvOperatorMenu"
          onKeyDownCapture={(event) => {
            if (event.key === "Escape") {
              setToolsOpen(false);
              event.currentTarget.querySelector("summary")?.focus();
            }
          }}
          open={toolsOpen}
          onToggle={(event) => setToolsOpen(event.currentTarget.open)}
        >
          <summary>
            <span className="tpvAvatar">
              {(user?.fullname || "Usuario")
                .split(" ")
                .map((part) => part[0])
                .slice(0, 2)
                .join("")}
            </span>
            <strong>{user?.fullname || "Usuario"}</strong>
            <FiChevronDown aria-hidden="true" />
          </summary>
          <div className="tpvOperatorActions">
            <span className="tpvMenuCaption">SESIÓN DEL PUESTO</span>
            <button
              type="button"
              className="headerAction"
              aria-label="Cambiar usuario"
              disabled={busy}
              onClick={() => handleMenu("switchAccount")}
              onKeyDown={(event) => keyboardAction(event, () => handleMenu("switchAccount"))}
            >
              <LiaExchangeAltSolid aria-hidden="true" />
              Cambiar usuario
            </button>
            <button
              type="button"
              className="logoutControl"
              onClick={logOff}
              onKeyDown={(event) => keyboardAction(event, logOff)}
              disabled={busy}
              aria-label={loggingOut ? "Cerrando sesión" : "Cerrar sesión"}
            >
              <HiLogout aria-hidden="true" />
              {loggingOut ? "Cerrando sesión…" : "Cerrar sesión"}
            </button>
          </div>
        </details>
        {pending && !loggingOut && (
          <span role="status" className="headerActionStatus">
            Guardando cambios…
          </span>
        )}
      </header>
      <nav className="tpvBottomNav" aria-label="Navegación del TPV">
        <button
          type="button"
          className={componentActive === "commander" ? "is-active" : ""}
          aria-label="TPV"
          aria-pressed={componentActive === "commander"}
          disabled={busy}
          onClick={() => handleMenu("commander")}
          onKeyDown={(event) => keyboardAction(event, () => handleMenu("commander"))}
        >
          <FiShoppingCart aria-hidden="true" />
          <span>Venta</span>
        </button>
        <button
          type="button"
          className={componentActive === "history" ? "is-active" : ""}
          aria-label="Historial"
          aria-pressed={componentActive === "history"}
          disabled={busy}
          onClick={() => handleMenu("history")}
          onKeyDown={(event) => keyboardAction(event, () => handleMenu("history"))}
        >
          <VscHistory aria-hidden="true" />
          <span>Historial</span>
        </button>
        <button
          type="button"
          aria-label="Caja"
          className={componentActive === "cash" ? "is-active" : ""}
          aria-pressed={componentActive === "cash"}
          disabled={busy}
          onClick={() => handleMenu("cash")}
        >
          <LuWallet aria-hidden="true" />
          <span>Caja</span>
        </button>
      </nav>
    </>
  );
};
